// This will probably come from somewhere else in the future
export const supportedLanguages = [
  {
    id: 'en',
    text: 'English',
    value: 'en',
  },
  {
    id: 'de',
    text: 'German',
    value: 'de',
  },
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number]['id'];

export const systemDefaultLanguageCode: SupportedLanguage = 'en';

export const isSupportedLanguage = (value: string): boolean => {
  return supportedLanguages.map((x) => x.value).includes(value as SupportedLanguage);
};

// House locale per language — the single place number/date/currency formats resolve from.
// Swap for a real Client.locale (BCP-47) when one exists; callers stay unchanged.
export const localeByLanguage: Record<SupportedLanguage, string> = {
  en: 'en-GB',
  de: 'de-DE',
};

// Resolve a BCP-47 locale from a language code; unknown/empty falls back to the default locale.
export const localeForLanguage = (lang?: string | null): string =>
  localeByLanguage[lang as SupportedLanguage] ?? localeByLanguage[systemDefaultLanguageCode];
